import {
  mediaFragment,
  responsiveMediaFragment
} from '~/gql/mediaFragments.gql'
import {
  seoFragment,
  productCardFragment,
  dataCaptureBlock
} from '@/gql/fragments.gql.js'

import { athleteListGql } from './athlete.gql'

export const articleHero = `
  ${mediaFragment('image', '{ q: 40 }')}
  ${mediaFragment('mobileImage', '{ q: 40 }')}
  ${mediaFragment('video', null, false)}
  ${mediaFragment('mobileVideo', null, false)}
  subtitle
  subtitleGradient
  overlayOpacity
`

const articleMeta = `
metaItems {
  title
  collaborator {
    ... on AthleteRecord {
      id
      title
      ${mediaFragment('avatar', '{ w: "150", h: "150", fit: fill }')}
      socialHandle
      socialHandleType
    }
    ... on AuthorRecord {
      id
      name
      ${mediaFragment('avatar', '{ w: "150", h: "150", fit: fill }')}
      socialHandle
      socialHandleType
    }
  }
}
`


// @TODO Hero content, article content
export const articleGql = `
query Article ($slug: String!) {
  article(filter: { slug: { eq: $slug } }) {
    id
    title
    slug
    fullWidthTitle
    date
    category {
      id
      title
      slug
    }
    _firstPublishedAt
    createdAt
    forceWidth
    forceDoubleWidth
    ${articleHero}
    content {
      value
      links
      blocks {
        ... on LargeCopyRecord {
          __typename
          _modelApiKey
          id
          smallText
          copy
        }
        ... on ArticleImageRecord {
          __typename
          _modelApiKey
          id
          caption
          credit
          ${responsiveMediaFragment()}
          productCards {
            title
            product {
              sku
              title
              subTitle
              frameSwatchOverride
              lensSwatchOverride
              swatchIconOverride {
                url(imgixParams: {w: "50", h: "50"})
              }
              lensPart
              limitedEdition
              ${mediaFragment('logo', '{ w: "200", h: "100", fit: fill }')}
              stockManagedPart
              theme
              baseProduct {
                sku
              }
            }
          }
        }
        ... on ArticleProductCardRecord {
          __typename
          _modelApiKey
          id
          heading
          productCard {
            ${productCardFragment}
          }
        }
        ... on ArticleVideoRecord {
          __typename
          _modelApiKey
          id
          video {
            url
            thumbnailUrl
            height
            width
            provider
            providerUid
            title
          }
        }
        ... on ArticleCarouselRecord {
          __typename
          _modelApiKey
          id
          caption
          credit
          ${responsiveMediaFragment('images')}
        }
        ... on ArticleAnchorTargetRecord {
          __typename
          _modelApiKey
          id
          sectionId
        }
        ... on InlineDataCaptureFormRecord {
          __typename
          _modelApiKey
          id
          block {
            ${dataCaptureBlock}
          }
        }
      }
    }
    metaGroupTitle
    ${articleMeta}
    tags {
      id
      title
    }
    ${seoFragment}
  }
}
`

export function buildArticleListGql (categoryId) {
  const categoryFilter = categoryId
    ? `filter: {category: {eq: "${categoryId}"}}, `
    : ''

  return `query Articles ($offset: IntType!, $limit: IntType!) {
    articlesMeta: _allArticlesMeta${categoryFilter ? '(' + categoryFilter + ')' : ''} {
      count
    }
    allArticles(
      ${categoryFilter}
      skip: $offset,
      first: $limit,
      orderBy: date_DESC
    ) {
      id
      title
      subtitle
      slug
      date
      category {
        id
        title
        slug
      }
      _firstPublishedAt
      ${mediaFragment('media')}
      forceWidth
      forceDoubleWidth
      contentWordCounter
    }
  }`
}

export function buildMultiFilteredArticleListGql (categoryId, limit) {
  const categoryFilter = categoryId
  ? `filter: {category: {in: ${categoryId}}}, `
  : ''

  const limitRecords = limit
  ? `first: "${limit}", `
  : ''

  return `query Articles {
    allArticles(
      ${categoryFilter}
      ${limitRecords}
      orderBy: date_DESC
    ) {
      id
      title
      subtitle
      slug
      ${mediaFragment('media')}
      category {
        slug
      }
    }
  }`
}

export const articlesByTagIdsGql = `
query ArticlesByTagIds (
  $tagIds: [ItemId!],
  $excludeArticleId: ItemId!,
  $limit: IntType!
) {
  allArticles(filter: {
    tags: {anyIn: $tagIds},
    id: {neq: $excludeArticleId}
  }, first: $limit, orderBy: _firstPublishedAt_DESC) {
    id
    title
    slug
    date
    category {
      id
      title
      slug
    }
    contentWordCounter
  }
}`

export function buildArticleAndAthleteListQuery (categoryId) {
  // Strip last } from articleGql
  const articleListQuery = buildArticleListGql(categoryId).replace(/}$/, '')
  
  // Strip operation names from athleteListGql
  const athleteListQuery = athleteListGql.replace(/query.+/, '')

  return `
  ${articleListQuery}
  ${athleteListQuery}
  `
}
